<template>
    <v-container fluid>
      <carga-masiva />
    </v-container>
  </template>
  <script>
  import CargaMasiva from '../components/CargarManifiestoCL.vue'
  export default {
    components: { CargaMasiva }
  }
  </script>
  
  <style>
  
  </style>
  